import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import logo from '../../assets/images/purrserlogo_new.png';

export const PageHeader = ({ header }: { header: string }) => {
  return (
    <>
      <Row className="page-header" style={{ marginRight: '0.2rem' }}>
        <Col>
          <Link to="/">
            <img height="120px" width="auto" id="brand-logo" src={logo} alt="local wallet" />
          </Link>
        </Col>
        <Col className="ms-auto">
          <h2>{header}</h2>
        </Col>
      </Row>

      <hr id="navbar-line" />
    </>
  );
};

export default PageHeader;
